import {Typography, TypographyProps} from '@mui/material'
import React from 'react'

export const CardTitle: React.FC<TypographyProps> = (props) => (
  <Typography variant="h4" mb={{xs: 2, md: 3}} {...props} />
)
